import React, { ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';

import NotFound from 'components/shared/notFound/page/NotFound';

interface SwitchWith404Props {
    children: ReactNode;
}

const SwitchWith404 = ({ children }: SwitchWith404Props) => (
    <Routes>
        {children}
        <Route path="*" element={<NotFound />} />
    </Routes>
);

export default SwitchWith404;
